import Message from 'components/Message/Message';
import useAppSetup from 'hooks/useAppSetup';
import AppRouter from 'router/AppRouter';

const App = () => {
  useAppSetup();

  return (
    <>
      <AppRouter />
      <Message />
    </>
  );
};

export default App;
